import { Icon, IconProps } from '@chakra-ui/react';

function PuzzlePieceIcon(props: IconProps): JSX.Element {
  return (
    <Icon
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9.25 5.29565H8.5V3.29565C8.5 2.74565 8.05 2.29565 7.5 2.29565H5.5V1.54565C5.5 0.855654 4.94 0.295654 4.25 0.295654C3.56 0.295654 3 0.855654 3 1.54565V2.29565H1C0.45 2.29565 0.005 2.74565 0.005 3.29565V5.19565H0.75C1.495 5.19565 2.1 5.80065 2.1 6.54565C2.1 7.29065 1.495 7.89565 0.75 7.89565H0V9.79565C0 10.3457 0.45 10.7957 1 10.7957H2.9V10.0457C2.9 9.30065 3.505 8.69565 4.25 8.69565C4.995 8.69565 5.6 9.30065 5.6 10.0457V10.7957H7.5C8.05 10.7957 8.5 10.3457 8.5 9.79565V7.79565H9.25C9.94 7.79565 10.5 7.23565 10.5 6.54565C10.5 5.85565 9.94 5.29565 9.25 5.29565Z" />
    </Icon>
  );
}

export { PuzzlePieceIcon };
